import AssetListContainer from './AssetList';

export default AssetListContainer;
